// plugins/gsap.js - we are already transpiling gsap, so it can be imported in server builds, pretty neat :)

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { CustomEase } from 'gsap/CustomEase'
import { CustomWiggle } from 'gsap/CustomWiggle'
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
// import { Draggable } from 'gsap/Draggable'
// import { ExpoScaleEase } from 'gsap/EasePack'

export default defineNuxtPlugin(() => {
	gsap.registerPlugin(

		ScrollTrigger,
		SplitText,
		CustomEase,
		CustomWiggle
	)

	// later you can use them by deconstructing useNuxtApp composable
	// but everything you put in provide will be prefixed with `$` symbol to 
	// prevent some collisions
	return {
		provide: {
			gsap,

			ScrollTrigger,
			SplitText,
			CustomEase,
			CustomWiggle
		}
	}
})